import { StringEnum } from "../../utils/string-enum.js";
import { getBrickManifestDefaults } from "../../brick-manifest.js";
import { examples as examples$13, manifest as manifest$12 } from "./navbar.manifest.js";
import { examples as examples$6, manifest as manifest$5 } from "./footer.manifest.js";
import { examples as examples$1, manifest } from "./accordion.manifest.js";
import { examples as examples$2, manifest as manifest$1 } from "./box.manifest.js";
import { examples as examples$3, manifest as manifest$2 } from "./button.manifest.js";
import { examples as examples$4, manifest as manifest$3 } from "./card.manifest.js";
import { examples as examples$5, manifest as manifest$4 } from "./carousel.manifest.js";
import { examples as examples$7, manifest as manifest$6 } from "./form.manifest.js";
import { examples as examples$8, manifest as manifest$7 } from "./hero.manifest.js";
import { examples as examples$9, manifest as manifest$8 } from "./icon.manifest.js";
import { examples as examples$10, manifest as manifest$9 } from "./image.manifest.js";
import { examples as examples$11, manifest as manifest$10 } from "./images-gallery.manifest.js";
import { examples as examples$12, manifest as manifest$11 } from "./map.manifest.js";
import { examples as examples$14, manifest as manifest$13 } from "./sidebar.manifest.js";
import { examples as examples$15, manifest as manifest$14 } from "./social-links.manifest.js";
import { examples as examples$16, manifest as manifest$15 } from "./spacer.manifest.js";
import { examples as examples$17, manifest as manifest$16 } from "./testimonials.manifest.js";
import { examples as examples$18, manifest as manifest$17 } from "./text.manifest.js";
import { examples as examples$19, manifest as manifest$18 } from "./video.manifest.js";
import { examples as examples$20, manifest as manifest$19 } from "./html.manifest.js";
import { examples as examples$21, manifest as manifest$20 } from "./table.manifest.js";
import { examples as examples$22, manifest as manifest$21 } from "./tabs.manifest.js";
import { examples as examples$23, manifest as manifest$22 } from "./timeline.manifest.js";

//#region src/shared/bricks/manifests/all-manifests.ts
const manifests = {
	[manifest$17.type]: manifest$17,
	[manifest$7.type]: manifest$7,
	[manifest$9.type]: manifest$9,
	[manifest$18.type]: manifest$18,
	[manifest$3.type]: manifest$3,
	[manifest$11.type]: manifest$11,
	[manifest$6.type]: manifest$6,
	[manifest$13.type]: manifest$13,
	[manifest$10.type]: manifest$10,
	[manifest$4.type]: manifest$4,
	[manifest$12.type]: manifest$12,
	[manifest$5.type]: manifest$5,
	[manifest$2.type]: manifest$2,
	[manifest$8.type]: manifest$8,
	[manifest$14.type]: manifest$14,
	[manifest$1.type]: manifest$1,
	[manifest$15.type]: manifest$15,
	[manifest$16.type]: manifest$16,
	[manifest.type]: manifest,
	[manifest$19.type]: manifest$19,
	[manifest$20.type]: manifest$20,
	[manifest$21.type]: manifest$21,
	[manifest$22.type]: manifest$22
};
const defaultProps = {
	[manifest$17.type]: getBrickManifestDefaults(manifest$17),
	[manifest$7.type]: getBrickManifestDefaults(manifest$7),
	[manifest$9.type]: getBrickManifestDefaults(manifest$9),
	[manifest$18.type]: getBrickManifestDefaults(manifest$18),
	[manifest$3.type]: getBrickManifestDefaults(manifest$3),
	[manifest$13.type]: getBrickManifestDefaults(manifest$13),
	[manifest$11.type]: getBrickManifestDefaults(manifest$11),
	[manifest$6.type]: getBrickManifestDefaults(manifest$6),
	[manifest$10.type]: getBrickManifestDefaults(manifest$10),
	[manifest$4.type]: getBrickManifestDefaults(manifest$4),
	[manifest$12.type]: getBrickManifestDefaults(manifest$12),
	[manifest$5.type]: getBrickManifestDefaults(manifest$5),
	[manifest$2.type]: getBrickManifestDefaults(manifest$2),
	[manifest$8.type]: getBrickManifestDefaults(manifest$8),
	[manifest$14.type]: getBrickManifestDefaults(manifest$14),
	[manifest$1.type]: getBrickManifestDefaults(manifest$1),
	[manifest$15.type]: getBrickManifestDefaults(manifest$15),
	[manifest$16.type]: getBrickManifestDefaults(manifest$16),
	[manifest.type]: getBrickManifestDefaults(manifest),
	[manifest$19.type]: getBrickManifestDefaults(manifest$19),
	[manifest$20.type]: getBrickManifestDefaults(manifest$20),
	[manifest$21.type]: getBrickManifestDefaults(manifest$21),
	[manifest$22.type]: getBrickManifestDefaults(manifest$22)
};
const brickTypes = StringEnum([
	manifest$17.type,
	manifest$7.type,
	manifest$9.type,
	manifest$18.type,
	manifest$3.type,
	manifest$11.type,
	manifest$6.type,
	manifest$10.type,
	manifest$4.type,
	manifest$2.type,
	manifest$8.type,
	manifest$14.type,
	manifest$1.type,
	manifest$15.type,
	manifest$16.type,
	manifest.type,
	manifest$19.type,
	manifest$20.type,
	manifest$21.type,
	manifest$22.type
], {
	title: "Brick type",
	description: "The type of brick"
});
const examples = {
	[manifest$17.type]: examples$18,
	[manifest$7.type]: examples$8,
	[manifest$9.type]: examples$10,
	[manifest$18.type]: examples$19,
	[manifest$3.type]: examples$4,
	[manifest$11.type]: examples$12,
	[manifest$6.type]: examples$7,
	[manifest$13.type]: examples$14,
	[manifest$10.type]: examples$11,
	[manifest$4.type]: examples$5,
	[manifest$12.type]: examples$13,
	[manifest$5.type]: examples$6,
	[manifest$2.type]: examples$3,
	[manifest$8.type]: examples$9,
	[manifest$14.type]: examples$15,
	[manifest$1.type]: examples$2,
	[manifest$15.type]: examples$16,
	[manifest$16.type]: examples$17,
	[manifest.type]: examples$1,
	[manifest$19.type]: examples$20,
	[manifest$20.type]: examples$21,
	[manifest$21.type]: examples$22,
	[manifest$22.type]: examples$23
};

//#endregion
export { brickTypes, defaultProps, examples, manifests };
//# sourceMappingURL=all-manifests.js.map